module.exports = __webpack_public_path__ + "static/media/thumbnail.8d740598.jpg";